import BaseMediaLinkService from "./media-link-service";

class ChapterMediaLinkService extends BaseMediaLinkService {
  protected vertical: "development" | "chapter" = "chapter";
}

export default ChapterMediaLinkService;
